import React, { useEffect } from 'react';
import { appInsights } from '../../appInsights';
import FirstLastGoalsWC26 from '../../components/FirstLastGoalsWC26/FirstLastGoalsWC26';
import FixturesOfTheDayWC26 from '../../components/FixturesOfTheDayWC26/FixturesOfTheDayWC26';
import GroupWinnersWC26 from '../../components/GroupWinnersWC26/GroupWinnersWC26';
import FooterWC26 from '../../components/FooterWC26/FooterWC26';
import HeaderWC26 from '../../components/HeaderWC26/HeaderWC26';
import ScoreboardWC26 from '../../components/ScoreboardWC26/ScoreboardWC26';
import ScoringSystemWC26 from '../../components/ScoringSystemWC26/ScoringSystemWC26';
import SpecialEventsWC26 from '../../components/SpecialEventsWC26/SpecialEventsWC26';
import TeamListsWC26 from '../../components/TeamListsWC26/TeamListsWC26';
import TopScorersWC26 from '../../components/TopScorersWC26/TopScorersWC26';
import UserTeamsWC26 from '../../components/UserTeamsWC26/UserTeamsWC26';
import WC26ErrorBoundary from './WC26ErrorBoundary';
import './WorldCup2026.css';

function WorldCup2026() {
  useEffect(() => {
    appInsights.trackPageView({ name: window.location.pathname });

    const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (favicon) favicon.href = '/favicon_wc.ico';
  }, []);

  return (
    <div className="wc26-container">
      <HeaderWC26 />
      <WC26ErrorBoundary fallback={<div>Something went wrong. Please try again later.</div>}>
        <main className="wc26-main">
          <FixturesOfTheDayWC26 />
          <ScoreboardWC26 />
          <TopScorersWC26 />
          <GroupWinnersWC26 />
          <FirstLastGoalsWC26 />
          <SpecialEventsWC26 />
          <ScoringSystemWC26 />
          <TeamListsWC26 />
          <UserTeamsWC26 />
        </main>
      </WC26ErrorBoundary>
      <FooterWC26 />
    </div>
  );
}

export default WorldCup2026;
